import analyticsEngineerDemo from "../../assets/images/gifs/home_gifs/analytics_engr.gif";
import platformEngineerDemo from "../../assets/images/gifs/home_gifs/platform_engr.gif";
import dataEngineerDemo from "../../assets/images/gifs/home_gifs/data_engr.gif";
import dataGovernanceDemo from "../../assets/images/gifs/extension_gifs/prevent_costly_mistakes.png";
import guardrailsImage from "../../assets/images/pngs/guardrails.png";

// Logo imports
import snowflakeLogo from "../../assets/images/svgs/logo-svgs/Snowflake.svg";
import databricksLogo from "../../assets/images/svgs/logo-svgs/databricks-icon-seeklogo.svg";
import bigqueryLogo from "../../assets/images/svgs/logo-svgs/google-bigquery-logo-1.svg";
import dbtLogo from "../../assets/images/svgs/logo-svgs/dbt-seeklogo.svg";
import airflowLogo from "../../assets/images/svgs/logo-svgs/Apache Airflow.svg";
import githubLogo from "../../assets/images/svgs/logo-svgs/GitHub.svg";
import jiraLogo from "../../assets/images/svgs/logo-svgs/Jira.svg";

export const datamatesFeatures = {
  "current-context": {
    id: "current-context",
    title: "",
    subtitle: "DataMates understands your entire data ecosystem",
    description: "Get intelligent assistance across all your data workflows with AI teammates that maintain context, remember past work, and adapt to your team's standards.",
    highlights: [
      "Maintains full context across your data ecosystem",
      "Remembers past work and team patterns",
      "Adapts to your specific standards and workflows",
      "Provides intelligent suggestions based on your codebase"
    ],
    features: {
      "automate": {
        title: "Automate",
        description: "Handle routine data tasks automatically",
        demoSrc: "https://app.supademo.com/embed/cmc3yybag0015300ijqxn7sfw?embed_v=2&hide_controls=true&click_anywhere=true"
      },
      "optimize": {
        title: "Optimize",
        description: "Find and fix performance bottlenecks",
        demoSrc: "https://app.supademo.com/embed/cmc3zjoka000m380hizblkek3?embed_v=2&hide_controls=true&click_anywhere=true"
      },
      "migrate": {
        title: "Migrate",
        description: "Seamlessly move between platforms",
        demoSrc: "https://app.supademo.com/embed/cmc90puh200crzr0im3mzl6kq?embed_v=2&hide_controls=true&click_anywhere=true"
      },
      "guardrails": {
        title: "Guardrails",
        description: "Built-in safety and compliance",
        imageSrc: guardrailsImage
      }
    },
    demoSrc: "https://app.supademo.com/embed/cmc3yybag0015300ijqxn7sfw?embed_v=2&hide_controls=true&click_anywhere=true",
    icon: "🧠",
    color: "#3f8cff"
  },
  "analytics-engineering": {
    id: "analytics-engineering",
    title: "",
    subtitle: "Datamates accelerates dbt development",
    description: "Accelerate your dbt development with AI teammates that understand your models, lineage, and best practices. From writing SQL to optimizing transformations, get intelligent assistance throughout your analytics workflow.",
    highlights: [
      "Convert SQL queries to dbt models instantly",
      "Optimize model performance and reduce costs",
      "Generate comprehensive documentation",
      "Maintain data quality with automated testing"
    ],
    imageSrc: analyticsEngineerDemo,
    icon: "📊",
    color: "#10b981"
  },
  "platform-engineering": {
    id: "platform-engineering",
    title: "",
    subtitle: "Datamates automates Infra Management and Optimization",
    description: "Empower your platform team with AI teammates that handle infrastructure optimization, migration planning, and cost management across Snowflake, Databricks, and BigQuery.",
    highlights: [
      "Automated infrastructure optimization",
      "Cost monitoring and reduction strategies",
      "Performance tuning at scale",
      "Cross-platform migration assistance"
    ],
    imageSrc: platformEngineerDemo,
    icon: "⚙️",
    color: "#8b5cf6"
  }
};

export const integrations = [
  { 
    name: "Snowflake", 
    icon: "snowflake",
    logoPath: snowflakeLogo
  },
  { 
    name: "Databricks", 
    icon: "databricks",
    logoPath: databricksLogo
  },
  { 
    name: "BigQuery", 
    icon: "bigquery",
    logoPath: bigqueryLogo
  },
  { 
    name: "dbt", 
    icon: "dbt",
    logoPath: dbtLogo
  },
  { 
    name: "Airflow", 
    icon: "airflow",
    logoPath: airflowLogo
  },
  { 
    name: "GitHub", 
    icon: "github",
    logoPath: githubLogo
  },
  { 
    name: "Jira", 
    icon: "jira",
    logoPath: jiraLogo
  },
  { 
    name: "Many more and custom", 
    icon: "more",
    isMoreLink: true,
    href: "https://datamates-docs.myaltimate.com/components/integrations/airflow"
  }
];

export const stats = [
  { number: "Zero", label: "Context switching" },
  { number: "100%", label: "PII protection" },
  { number: "24/7", label: "Learning from your team" }
]; 